export const TAX_RATE = 9.25;
